import ContractsFieldLabel from "./ContractsFieldLabel";

export default function ContractsModalField({ label, renderValue }) {
  return (
    <div className="flex w-full flex-col gap-1">
      <ContractsFieldLabel value={label} />
      {renderValue}
    </div>
  );
}
